import React from 'react';
import { Typography } from 'fronton-react';
import { WarningCircleIcon } from '@fronton/icons-react';
import { cx } from 'linaria';
import { wrapper, description } from './style';

type Props = {
  message: string;
  title: string;
  className?: string;
};

export const DATA_QA_INLINE_NOTIFICATION = 'inline-notification';
export const DATA_QA_INLINE_NOTIFICATION_MESSAGE = 'inline-notification-message';
export const DATA_QA_INLINE_NOTIFICATION_TITLE = 'inline-notification-title';

export const InlineNotification: React.FC<Props> = ({ message, title, className = '' }) => (
  <div className={cx(wrapper, className)} data-qa={DATA_QA_INLINE_NOTIFICATION}>
    <WarningCircleIcon type="outline" size="l" />
    <div className={description}>
      <Typography variant="m" size="body_accent" data-qa={DATA_QA_INLINE_NOTIFICATION_TITLE}>
        {title}
      </Typography>
      <Typography variant="s" size="body_long" data-qa={DATA_QA_INLINE_NOTIFICATION_MESSAGE}>
        {message}
      </Typography>
    </div>
  </div>
);
